import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import {
	Icon,
	Url,
	TEXT_ALIGNMENT_OPTIONS,
	HERO_IMG_PLACEMENTS,
	HeroImagePlacements,
	TextAlignmentOptions,
} from '#const';
import { getIconUrl } from '#utils';

const ListAndImage = dynamic(() => import('./ListAndImage'));

Builder.registerComponent(ListAndImage, {
	name: 'ListAndImage',
	inputs: [
		{
			name: 'textSide',
			friendlyName: 'Text Side',
			type: 'string',
			enum: [...HERO_IMG_PLACEMENTS],
			defaultValue: HeroImagePlacements.LEFT,
			helperText: 'Which side of the section will the text fall?',
		},
		{
			name: 'heading',
			friendlyName: 'Heading Text',
			required: true,
			type: 'richText',
			defaultValue: '<h2>Why Get a Free Case Review?</h2>',
		},
		{
			name: 'headingAlignment',
			friendlyName: 'Heading Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
		},
		{
			name: 'items',
			type: 'list',
			required: true,
			subFields: [
				{
					name: 'icon',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
					required: false,
				},
				{
					name: 'heading',
					type: 'string',
					required: true,
				},
				{
					name: 'subheading',
					type: 'string',
					required: false,
				},
			],
			defaultValue: [
				{
					heading: "It's 100% Free & Easy",
					subheading: 'No upfront cost - pay nothing unless you get a settlement',
				},
				{
					heading: 'Advice from Legal Experts',
					subheading: 'Our team has helped more than 78,000 victims seek justice',
				},
				{
					heading: 'Possible Compensation',
					subheading: 'You may qualify for significant compensation',
				},
			],
		},
		{
			name: 'image',
			required: false,
			friendlyName: 'Image',
			type: 'file',
			allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
			defaultValue: {
				src: Url.PLACEHOLDER,
				alt: '',
			},
		},
		{
			name: 'mobileImage',
			friendlyName: 'Mobile Image',
			type: 'boolean',
			defaultValue: true,
			helperText: 'Should the Image appear on mobile?',
		},
		{
			name: 'color',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#F9FAFB',
		},
		{
			name: 'line',
			friendlyName: 'Dividing Line',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Include dividing line under the headline?',
		},
	],
	image: getIconUrl(Icon.IMAGE_TEXT_SECTION),
});
